module.exports = __webpack_public_path__ + "img/52.a6318e35.jpg";